export function ConditionalButton({
  condition,
  titleWhenTrue = "",
  titleWhenFalse = "",
  type = "button",
  onClick = () => {},
}) {
  return (
    <button
      type={type}
      className={`btn btn-${condition ? "success" : "warning"}`}
      onClick={onClick}
    >
      {condition ? titleWhenTrue : titleWhenFalse}
    </button>
  );
}
